import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '../../axios/axiosInstance';

export const useEmailValidation = () =>
  useMutation(async (payload) => {
    const { data } = await axiosInstance.post('/api/auth/member/validate-email', payload);
    return data;
  });
